import get from 'lodash/get';
import { createSelector } from 'reselect';
import { searchParametersSelector } from '../Serp/selectors';

const notificationsState = state => state.notifications;

export const getDealType = createSelector(
  searchParametersSelector,
  searchParameters => get(searchParameters, 'type_id') || 1
);

export const subscriptionIdSelector = createSelector(
  notificationsState,
  notifications => notifications.subscriptionId
);

export const infrastructureIdSelector = createSelector(
  notificationsState,
  notifications => notifications.infrastructureId
);

export const searchesSelector = createSelector(
  notificationsState,
  notifications => notifications.searches
);

export const isPushDismissedSelector = createSelector(
  notificationsState,
  notifications => notifications.isPushDismissed
);

export const isPushRequestedSelector = createSelector(
  notificationsState,
  notifications => notifications.isPushRequested
);

export const isExpiredSelector = createSelector(
  notificationsState,
  notifications => notifications.isExpired
);

export const resetSelector = createSelector(
  notificationsState,
  notifications => notifications.reset
);



// WEBPACK FOOTER //
// ./app/Notifications/selectors.js